import React, { useState } from "react";
import "./approach.css"
import Lottie from "react-lottie";

import AddIcon from "@mui/icons-material/Add"
import AllInclusive from "@mui/icons-material/AllInclusive"


import animationData from "../data/website1.json";
import backs from "../imgz/065.jpg"

const Approach = () => {

    const [isHovered, setIsHovered] = useState(false)
    const [isHovered2, setIsHovered2] = useState(false)
    const [isHovered3, setIsHovered3] = useState(false)  
    const [isHovered4, setIsHovered4] = useState(false)
    const [visib, setVisib] = useState(true)
    const [visib2, setVisib2] = useState(true)
    const [visib3, setVisib3] = useState(true)
    
    const handlehover1 = () =>{
         if(!isHovered){
            setVisib(false)
            setIsHovered(true)
            
         }else{
            setIsHovered(false)
            setVisib(true)
         }
         setIsHovered2(false)
         setIsHovered3(false)
         setIsHovered4(false)  
         
    }
    const handlehover2 = () =>{
        if(!isHovered2){
            setVisib2(false)
           setIsHovered2(true)
        }else{

           setIsHovered2(false)
           setVisib2(true)
        }
        setIsHovered(false)
        setIsHovered3(false)
        setIsHovered4(false)  
        
   }

   const handlehover3 = () =>{
    if(!isHovered3){
        setVisib3(false)
       setIsHovered3(true)
    }else{
       setIsHovered3(false)
       setVisib3(true)
    }
    setIsHovered(false)
    setIsHovered2(false)
    setIsHovered4(false)  
    
}

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

    
    
    return (
    <section className="approach-section">
      <h2 className="heading"
        data-aos="fade-zoom-in" data-aos-offset="200" data-aos-easing="ease-in-sine" data-aos-duration="600"
      >
        Our <span className="highlighted-text">approach</span>
      </h2>

      <div className="cardReveal" onMouseEnter={handlehover1} onMouseLeave={handlehover1} >
           <div className="addicon1" ><AddIcon fontSize="inherit" /></div>
           <div className="addicon2" ><AddIcon fontSize="inherit" /></div>
           <div className="addicon3" ><AddIcon fontSize="inherit" /></div>
           <div className="addicon4" ><AddIcon fontSize="inherit" /></div>
           <div className={`${visib ? "allinIcon" : "hewa" }`}  ><AllInclusive fontSize="inherit" /></div>
           <div className={`testDiv ${isHovered ? 'testDiv-expanded' : 'testDiv-collapsed'}`} > 
                
              <div className="lotirelativ" >
                      <img src={backs} alt="" classname="backimages" />
                    <h2 
                     data-aos="flip-left" data-aos-delay="100"
                    className="strategy" >Planning & Strategy</h2>
                    <h2 className="memo" >We'll collaborate to map out your website's goals, target audience, 
                        and key functionalities. We'll discuss things like site structure, 
                        navigation, and content requirements</h2>
                </div>  
              
           </div>
      </div>

      <div className="cardReveal" onMouseEnter={handlehover2} onMouseLeave={handlehover2} >
           <div className="addicon1" ><AddIcon fontSize="inherit" /></div>
           <div className="addicon2" ><AddIcon fontSize="inherit" /></div>
           <div className="addicon3" ><AddIcon fontSize="inherit" /></div>
           <div className="addicon4" ><AddIcon fontSize="inherit" /></div>
           <div className={`${visib2 ? "allinIcon" : "hewa" }`}  ><AllInclusive fontSize="inherit" /></div>
           <div className={`testDiv ${isHovered2 ? 'testDiv-expanded' : 'testDiv-collapsed'}`} > 
                     
           <div className="lotirelativ"
             data-aos="fade-up"
           >
           <img src={backs} alt="" classname="backimages"
           
           />
                <h2 className="strategy" >Development & Progress Update</h2>
                <h2 className="memo" >Once we agree on the plan, we cue our Psquare playlist and dive into
          coding. From initial sketches to polished code, we keep you updated
          every step of the way.</h2>
                </div>  

                


           
           </div>
      </div>

      <div className="cardReveal" onMouseEnter={handlehover3} onMouseLeave={handlehover3} >
           <div className="addicon1" ><AddIcon fontSize="inherit" /></div>
           <div className="addicon2" ><AddIcon fontSize="inherit" /></div>
           <div className="addicon3" ><AddIcon fontSize="inherit" /></div>
           <div className="addicon4" ><AddIcon fontSize="inherit" /></div>
           <div className={`${visib3 ? "allinIcon" : "hewa" }`}  ><AllInclusive fontSize="inherit" /></div>
           <div className={`testDiv ${isHovered3 ? 'testDiv-expanded' : 'testDiv-collapsed'}`} > 
                
           <div className="lotirelativ"   data-aos="flip-left" data-aos-delay="100" >
           <img src={backs} alt="" classname="backimages" />
                <h2 className="strategy" >Development & Launch</h2>
                <h2 className="memo" >This is where the magic happens! Based on the approved design, 
                  We'll translate everything into functional code, building your website/app
                  from the ground up</h2>
                </div>  

           </div>
      </div>

<h1 className="heading" 
    data-aos="flip-left" data-aos-delay="100"
>
 If u can imagine it <span className="highlighted-text"> We can build it</span>
</h1>
      <div className="webs" >
      <Lottie options={defaultOptions}  />
     </div>

          

      
    </section>
  );
};

export default Approach;

